export const tasksEnTranslations = {
  // Page
  pageTitle: 'Tasks',
  pageDescription: 'Manage and track all tasks across your projects',

  // Table Headers
  title: 'Title',
  creator: 'Creator',
  status: 'Status',
  assignees: 'Assignees',
  startDate: 'Start Date',
  dueDate: 'Due Date',
  goal: 'Goal',
  actions: 'Actions',

  // Status Values
  completed: 'Completed',
  inProgress: 'In Progress',
  notStarted: 'Not Started',
  blocked: 'Blocked',

  // Messages
  loadingTasks: 'Loading tasks...',
  errorLoadingTasks: (error: string) => `Error loading tasks: ${error}`,
  noTasksFound: 'No tasks found',
  showingTasks: (count: number) =>
    `Showing ${count} task${count !== 1 ? 's' : ''}`,

  // Actions
  createTask: 'Create Task',
  editTask: 'Edit Task',
  deleteTask: 'Delete Task',
  viewDetails: 'View Details',
};
